import { useI18n } from 'app/components/localization';
import { SelectField } from 'app/components/presentation/forms/Fields';
import { getNameWithOffset, TIMEZONES } from 'app/constants/schemas/Timezone';
import { TimezoneType } from 'app/services/localization';
import React, { FunctionComponent } from 'react';

const TIMEZONE_NAMES = TIMEZONES.map(({ name }) => name);

interface ITimezoneProps {
  label?: string;
  onChange: (val: TimezoneType) => void;
  value?: TimezoneType;
}

const Timezone: FunctionComponent<ITimezoneProps> = ({ label, value, onChange }) => {
  const { t } = useI18n();

  return (
    <SelectField
      label={label}
      onSelect={onChange}
      optionIds={TIMEZONE_NAMES}
      renderOption={(name) => {
        return name ? getNameWithOffset(name) : t('forms.timezone.unselected');
      }}
      selectedId={value}
    />
  );
};

export default Timezone;
